import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-brand-ivory pt-[100px] md:pt-[140px] pb-[48px] md:pb-[80px] overflow-hidden relative" data-id="element-198">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-brand-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-199"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-brand-coral/5 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3 pointer-events-none" data-id="element-200"></div>

      <div className="container-custom grid md:grid-cols-2 gap-12 md:gap-16 items-center relative z-10" data-id="element-201">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-start gap-6 md:gap-8" data-id="element-202">
          <div className="badge bg-brand-gold/20 text-brand-coral" data-id="element-203">
            PSIHOLOGIE & DEZVOLTAREA COPILULUI
          </div>

          <h1 className="text-[32px] md:text-[48px] lg:text-[56px] text-brand-navy relative" data-id="element-204">
            De la îngrijorare și confuzie, la un copil care crește frumos
            <svg className="absolute -bottom-4 left-0 w-32 h-4 text-brand-gold" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-205">
              <path d="M0 5 Q 50 10 100 5" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" data-id="element-206" />
            </svg>
          </h1>

          <p className="text-[16px] md:text-[18px] text-brand-text max-w-[680px]" data-id="element-207">
            Ghidez mamele de copii între 1 și 4 ani care nu vorbesc sau vorbesc
            prea puțin să își ajute copiii să se dezvolte armonios, prin joc și
            conectare, folosind rutine zilnice simple, fără jucării scumpe și
            tehnici complicate.
          </p>

          <div className="flex flex-col gap-4 w-full md:w-auto mt-2" data-id="element-208">
            <a href="#mini-curs" className="btn-primary" data-id="element-209">
              Descarcă Ghidul Gratuit
            </a>
            <p className="font-source text-[13px] md:text-[14px] text-brand-textSecondary italic text-center md:text-left max-w-[400px]" data-id="element-210">
              Dacă simți că ai căutat multe răspunsuri și tot nu știi de unde să
              începi, nu e vina ta. E nevoie de un ghid clar și de sprijin real.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative h-[450px] md:h-[600px] w-full" data-id="element-211">
          {/* Decorative Blob Behind Image */}
          <svg className="absolute -top-10 -right-10 w-[120%] h-[120%] text-brand-gold/15 -z-10 animate-[spin_60s_linear_infinite]" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" data-id="element-212">
            <path fill="currentColor" d="M44.7,-76.4C58.8,-69.2,71.8,-59.1,81.3,-46.3C90.8,-33.5,96.8,-18,96.5,-2.7C96.2,12.6,89.6,27.7,80.1,40.7C70.6,53.7,58.2,64.6,44.2,72.4C30.2,80.2,15.1,84.9,-0.3,85.4C-15.7,85.9,-31.4,82.2,-45.5,74.5C-59.6,66.8,-72.1,55.1,-80.6,41.1C-89.1,27.1,-93.6,10.8,-92.4,-5.1C-91.2,-21,-84.3,-36.5,-74.4,-49.2C-64.5,-61.9,-51.6,-71.8,-37.8,-79.1C-24,-86.4,-9.3,-91.1,3.2,-86.6C15.7,-82.1,30.6,-83.6,44.7,-76.4Z" transform="translate(100 100)" data-id="element-213" />
          </svg>

          {/* Dots Pattern */}
          <svg className="absolute -bottom-8 -left-8 w-24 h-24 text-brand-coral/40 -z-10" viewBox="0 0 100 100" data-id="element-214">
            <defs data-id="element-215">
              <pattern id="dots" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse" data-id="element-216">
                <circle cx="2" cy="2" r="2" fill="currentColor" data-id="element-217" />
              </pattern>
            </defs>
            <rect x="0" y="0" width="100" height="100" fill="url(#dots)" data-id="element-218" />
          </svg>

          {/* Main Image */}
          <div className="w-full h-full rounded-[24px] rounded-tr-[80px] rounded-bl-[80px] overflow-hidden shadow-card border-4 border-white relative z-10" data-id="element-219">
            <img src="https://cdn.magicpatterns.com/uploads/umdfvnus8nEP6agRs8rG6B/Cristina_poze_%281%29.jpg" alt="Cristina Geană în sesiune cu o mamă" className="w-full h-full object-cover" data-id="element-220" />
            <div className="absolute inset-0 bg-brand-navy/10 mix-blend-multiply" data-id="element-221"></div>
          </div>

          {/* Floating Badge */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.8,
          duration: 0.5
        }} className="absolute -bottom-6 -left-6 md:bottom-10 md:-left-12 bg-white p-4 rounded-[16px] shadow-card flex items-center gap-4 z-20 border border-brand-beige" data-id="element-222">
            <div className="w-12 h-12 rounded-full bg-brand-gold/20 flex items-center justify-center text-brand-coral" data-id="element-223">
              <StarIcon size={24} fill="currentColor" data-id="element-224" />
            </div>
            <div data-id="element-225">
              <p className="font-montserrat font-bold text-[18px] text-brand-navy leading-none mb-1" data-id="element-226">
                11+ ani
              </p>
              <p className="font-source text-[13px] text-brand-textSecondary leading-none" data-id="element-227">
                experiență clinică
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}